import { useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";

import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import EventsTable from "./components/EventsTable";
import Button from "@/components/Button";
import EventsModal from "./components/EventsModal";

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ProductionEvents = () => {
  const [showEventModal, setShowEventModal] = useState(false);

  return (
    <>
      <TeamHeading />
      <HeadingRow>
        <PageHeading>Project Events</PageHeading>
        <Button onClick={() => setShowEventModal(true)}>Create new</Button>
      </HeadingRow>
      <EventsTable />
      <AnimatePresence>
        {showEventModal && (
          <EventsModal onClose={() => setShowEventModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default ProductionEvents;
